module.exports = __webpack_public_path__ + "img/loaderV5.65dd71f8.gif";